/**
 *
 * @param {Object} options
 *
 * @param {String} options.modalTitle
 * @param {String} options.atcLabel
 * @param {String} [options.modalTemplate] Custom modal template
 * @param {Function} [options.fallback] Custom fallback function
 * @returns
 */
var QuickAddModal = function (options) {
  var _state = {
    currentProductData: {},
    selectedVariantIdx: 0,
    initialised: false,
    background: $(".generic-overlay-bg"),
    modalRoot: null,
  };

  var _settings = {
    modalTitle: "Select Options",
    atcLabel: "Add to Cart",
    backgroundTemplate: `<div class="generic-overlay-bg"></div>`,
    modalTemplate: `<div id="modal-quickadd-v2" role="dialog">
    <button class="Modal__Close Modal__Close--outside" data-action="close-modal" data-target="#modal-quickadd">
      <svg class="Icon Icon--close  " role="presentation" viewBox="0 0 16 14">
        <path d="M15 0L1 14m14 0L1 0" stroke="currentColor" fill="none" fill-rule="evenodd"></path>
      </svg>
    </button>
    <header class="Modal__Header">
      <h3 class="Modal__Title Heading u-h2">{{MODAL_TITLE}}</h3>
    </header>
  
    <div class="Modal__Product">
      <div class="Modal__Product-Image images js-image-quickadd">
        <img class="ProductItem__Image" width="160" height="160" src="{{PRODUCT_IMAGE}}" alt="Product image">
      </div>
      <div class="Modal__Product-Info">
        <h3 class="Modal__Product-Title js-title-quickadd">{{PRODUCT_TITLE}}</h3>
        <div class="price Modal__Product-Price js-price-quickadd">{{PRODUCT_PRICE}}</div>
      </div>
    </div>
    <div class="swatch js-swatch-quickadd">
      <div class="swatch-title">
        <span class="js-swatch-title">{{OPTION_NAME}}: </span>
        <span class="Modal__Swatch-Title js-swatch-title-selected">{{CURRENT_SELECTION}}</span>
      </div>
      {{OPTIONS}}
    </div>
    <div class="Modal__Add-To-Card">
      <div class="QuantitySelector Modal__Selector js-quantity-change">
        <div class="QuantitySelector__Button Link Link--secondary" data-action="decrease-quantity">
          <svg class="Icon Icon--minus-outline modal-quickadd__icon " xmlns="http://www.w3.org/2000/svg" fill="none"
            viewBox="0 0 20 20">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M15.625 10H4.375"></path>
          </svg>
        </div>
        <input type="text" class="QuantitySelector__CurrentQuantity Modal__Current-Quantity" pattern="[0-9]*"
          name="quantity" value="1">
        <div class="QuantitySelector__Button Link Link--secondary" data-action="increase-quantity">
          <svg class="Icon Icon--plus-outline modal-quickadd__icon " xmlns="http://www.w3.org/2000/svg" fill="none"
            viewBox="0 0 20 20">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
              d="M10 4.375v11.25M15.625 10H4.375"></path>
          </svg>
        </div>
      </div>
      <button type="submit" class="Button Button--primary js-button-atc Modal__Button" data-variant-selected
        data-quantity="1">
        <span>{{ATC_TEXT}}</span>
      </button>
    </div>
  </div>
  </div>`,
    colourSwatchTemplate: `<div class="ProductItem__ColorSwatchItem ProductItem__ColorSwatch{{AVAILABLE}}">
	<input class="ColorSwatch__Radio" type="radio" name="collection-template-{{PRODUCT_ID}}-swatch" 
    id="collection-template-{{PRODUCT_ID}}-swatch-{{SWATCH_IDX}}" data-variant-index="{{SWATCH_IDX_0}}" 
		data-variant-id="{{VARIANT_ID}}" value="{{VARIANT_TITLE}}" data-image-aspect-ratio="1"
		data-variant-price="{{VARIANT_PRICE}}" data-variant-compare-at-price="{{VARIANT_COMPARE_AT_PRICE}}"
		data-variant-url="{{VARIANT_URL}}" data-image-url="{{VARIANT_IMAGE}}"
		data-image-widths="[200,400,600,700,800,900,1000,1200]" aria-hidden="true"{{CHECKED}}>
	<label class="ColorSwatch ColorSwatch--small" for="collection-template-{{PRODUCT_ID}}-swatch-{{SWATCH_IDX}}"
		style="background-color: {{BACKGROUND_COLOUR}}; background-image: url({{BACKGROUND_IMAGE}})"
		title="{{VARIANT_TITLE}}" data-tooltip="{{VARIANT_TITLE}}"></label>
</div>`,
    optionPillTemplate: `<div class="ProductItem__ColorSwatchItem ProductItem__Pill">
    <input class="ColorSwatch__Radio" type="radio"
        id="collection-template-{{PRODUCT_ID}}-{{OPTION_NAME_LOWER}}-{{OPTION_IDX}}" data-variant-index="{{OPTION_IDX_0}}" 
        name="collection-template-{{PRODUCT_ID}}-{{OPTION_NAME_LOWER}}" data-variant-id="{{VARIANT_ID}}"
        value="{{VARIANT_TITLE}}" data-variant-price="{{VARIANT_PRICE}}"
        data-variant-comapre-at-price="{{VARIANT_COMPARE_AT_PRICE}}" aria-hidden="true"{{CHECKED}}/>
    <label class="ColorSwatch ColorSwatch--size"
        for="collection-template-{{PRODUCT_ID}}-{{OPTION_NAME_LOWER}}-{{OPTION_IDX}}" title="{{VARIANT_TITLE}}"
        data-tooltip="{{VARIANT_TITLE}}">{{VARIANT_TITLE}}</label>
</div>`,
  };

  _settings = Object.assign({}, _settings, options);

  var self = this;

  this.getState = function () {
    return { ..._state };
  };

  this.getSettings = function () {
    return { ..._settings };
  };

  this.show = function (loading) {
    _state.modalRoot.toggleClass("visible", true);
    _state.modalRoot.toggleClass("skeleton", loading);
    _state.background.toggleClass("visible", true);
    $("html").toggleClass("no-scroll", true);
  };

  this.hide = function () {
    _state.modalRoot.toggleClass("visible", false);
    _state.background.toggleClass("visible", false);
    $("html").toggleClass("no-scroll", false);
  };

  this.changeVariant = function (elem) {
    _state.selectedVariantIdx = parseInt($(elem).attr("data-variant-index"));

    var newVariantData =
      _state.currentProductData.variants[_state.selectedVariantIdx];

    if (newVariantData?.image?.url)
      _state.modalRoot
        .find(".ProductItem__Image")
        .attr("src", newVariantData.image.url);
    _state.modalRoot.find(".ColorSwatch__Radio:checked").prop("checked", "");

    $(elem).prop("checked", 1);

    _state.modalRoot
      .find(".js-button-atc")
      .attr("data-variant-selected", $(elem).attr("data-variant-id"));

    _state.modalRoot
      .find(".js-button-atc")
      .prop("disabled", !newVariantData.available);

    _state.modalRoot
      .find(".js-button-atc > span")
      .text(newVariantData.available ? "Add to Cart" : "Back Soon");

    _state.modalRoot
      .find(".js-price-quickadd")
      .text("$" + newVariantData.price);

    _state.modalRoot
      .find(".js-swatch-title-selected")
      .text(newVariantData.title);

    // self.updateModal(_state.currentProductData, false);
  };

  this.addToCart = function (variantId, quantity) {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: "/cart/add.js",
        type: "post",
        dataType: "json",
        data: {
          items: [
            {
              id: variantId,
              quantity: quantity,
            },
          ],
        },
        success: resolve,
        error: reject,
        timeout: reject,
      });
    });
  };

  this.updateModal = function (productData, autoOpen = true) {
    _state.currentProductData = productData;
    _state.selectedVariantIdx = 0;

    var template = compileTemplate(productData);

    _state.modalRoot.html($(template).html());

    if (autoOpen) self.show(false);

    _state.modalRoot.toggleClass("skeleton", false);
  };

  function getModalOptions(productData) {
    const swatchOptionNames = ["colour", "color", "shade"];

    if (
      swatchOptionNames.includes(productData.options[0].name.toLowerCase()) &&
      typeof productData.variants[0].metafields !== "undefined"
    ) {
      return '<div class="ProductItem__ColorSwatchList">{{SWATCHES}}</div>'.replace(
        /{{SWATCHES}}/g,
        productData.variants
          .map(function (variantData, idx) {
            var productId = productData.id.replace(
              "gid://shopify/Product/",
              "",
            );
            var variantId = variantData.id.replace(
              "gid://shopify/ProductVariant/",
              "",
            );
            return _settings.colourSwatchTemplate
              .replace(/{{PRODUCT_ID}}/g, productId)
              .replace(
                /{{AVAILABLE}}/g,
                variantData.available ? "" : " sold-out",
              )
              .replace(/{{SWATCH_IDX}}/g, idx + 1)
              .replace(/{{SWATCH_IDX_0}}/g, idx)
              .replace(/{{VARIANT_TITLE}}/g, variantData.title)
              .replace(/{{VARIANT_ID}}/g, variantId)
              .replace(/{{VARIANT_PRICE}}/g, variantData.price)
              .replace(
                /{{VARIANT_COMPARE_AT_PRICE}}/g,
                variantData.compare_at_price || 0,
              )
              .replace(
                /{{VARIANT_URL}}/g,
                "/products/" + productData.handle + "?variant=" + variantId,
              )
              .replace(/{{VARIANT_IMAGE}}/g, variantData?.image?.url || "")
              .replace(
                /{{BACKGROUND_COLOUR}}/g,
                variantData?.metafields?.fields?.find(
                  (field) => field.key === "colour_picker",
                ).value ?? "",
              )
              .replace(
                /{{BACKGROUND_IMAGE}}/g,
                variantData?.metafields?.fields?.find(
                  (field) => field.key === "image",
                )?.image?.image?.url ?? "",
              )
              .replace(
                /{{CHECKED}}/g,
                _state.selectedVariantIdx === idx ? " checked" : "",
              );
          })
          .join(""),
      );
    }

    // Render other option types as pills
    return '<div class="ProductItem__OptionList">{{OPTIONS}}</div>'.replace(
      /{{OPTIONS}}/g,
      productData.options
        .map(function (option, optionIdx) {
          var productId = productData.id.replace("gid://shopify/Product/", "");
          return option.values
            .map(function (optionValue, optionValueIdx) {
              var matchingVariant = productData.variants.find(
                function (variant) {
                  return variant.selectedOptions.every(
                    function (variantSelectedOption) {
                      return (
                        variantSelectedOption.name === option.name &&
                        variantSelectedOption.value === optionValue
                      );
                    },
                  );
                },
              );
              var variantId = matchingVariant.id.replace(
                "gid://shopify/ProductVariant/",
                "",
              );
              return _settings.optionPillTemplate
                .replace(/{{PRODUCT_ID}}/g, productId)
                .replace(/{{OPTION_NAME_LOWER}}/g, option.name.toLowerCase())
                .replace(/{{OPTION_IDX}}/g, optionValueIdx + 1)
                .replace(/{{OPTION_IDX_0}}/g, optionValueIdx)
                .replace(/{{VARIANT_ID}}/g, variantId)
                .replace(/{{VARIANT_TITLE}}/g, matchingVariant.title)
                .replace(/{{VARIANT_PRICE}}/g, matchingVariant.price)
                .replace(
                  /{{VARIANT_COMPARE_AT_PRICE}}/g,
                  matchingVariant.compare_at_price || 0,
                )
                .replace(
                  /{{CHECKED}}/g,
                  _state.selectedVariantIdx === optionValueIdx
                    ? " checked"
                    : "",
                );
            })
            .join("");
        })
        .join(""),
    );
  }

  function compileTemplate(productData) {
    if (!productData)
      productData = {
        __typename: "Product",
        id: "gid://shopify/Product/0",
        handle: "/",
        title: "",
        options: [
          {
            name: "...",
            values: ["..."],
          },
        ],
        featured_image: {
          url: "",
        },
        variants: [
          {
            __typename: "ProductVariant",
            id: "gid://shopify/ProductVariant/44184872091877",
            title: "",
            price: "...",
            compare_at_price: null,
            image: {
              url: "",
            },
            selectedOptions: [
              {
                name: "...",
                value: "...",
              },
            ],
            __parentId: "gid://shopify/Product/7722577199333",
            namespace: "custom",
            key: "colour_swatch_data",
            reference: {},
            metafields: {
              fields: [
                {
                  key: "title",
                  value: "...",
                  image: null,
                },
                {
                  key: "image",
                  value: null,
                  image: null,
                },
                {
                  key: "colour_picker",
                  value: "#e9bfb6",
                  image: null,
                },
                {
                  key: "category",
                  value: "[]",
                  image: null,
                },
              ],
            },
          },
        ],
      };

    return _settings.modalTemplate
      .replace(/{{MODAL_TITLE}}/g, _settings.modalTitle)
      .replace(/{{ATC_TEXT}}/g, _settings.atcLabel)
      .replace(
        /{{PRODUCT_IMAGE}}/g,
        productData?.variants?.[_state.selectedVariantIdx]?.image?.url ??
          productData?.featured_image?.url ??
          "",
      )
      .replace(
        /{{PRODUCT_PRICE}}/g,
        Shopify.formatMoney(
          productData.variants[_state.selectedVariantIdx].price,
        ),
      )
      .replace(/{{PRODUCT_TITLE}}/g, productData.title)
      .replace(/{{OPTION_NAME}}/g, productData.options[0].name)
      .replace(
        /{{CURRENT_SELECTION}}/g,
        productData.variants[_state.selectedVariantIdx].title,
      )
      .replace(/{{OPTIONS}}/g, getModalOptions(productData));
  }
  function insertHtml() {
    if (!_state.background.length)
      _state.background = $(_settings.backgroundTemplate).appendTo("body");

    var template = compileTemplate();

    _state.modalRoot = $(template).appendTo("body");
  }

  function setupEvents() {
    _state.modalRoot.on("click", '[data-action="close-modal"]', function (e) {
      e.preventDefault();

      self.hide();
    });

    _state.background.on("click", function (e) {
      self.hide();
    });

    _state.modalRoot.on(
      "change",
      '[name*="collection-template-"]',
      function (e) {
        self.changeVariant(this);
      },
    );

    _state.modalRoot.on("click", ".js-button-atc", function (e) {
      var variantId = _state.currentProductData.variants[
        _state.selectedVariantIdx
      ].id.replace("gid://shopify/ProductVariant/", "");
      var qty = _state.modalRoot.find(".Modal__Current-Quantity").val();

      if (!variantId || qty <= 0) return;

      self.addToCart(variantId, qty);
    });

    _state.modalRoot.on(
      "click",
      '[data-action="increase-quantity"]',
      function (e) {
        var qtyInput = $(this).siblings('[name="quantity"]');
        var currentQty = parseInt(qtyInput.val());

        var newQty = currentQty + 1;

        qtyInput.val(newQty);

        _state.modalRoot.find(".js-button-atc").attr("data-quantity", newQty);
      },
    );

    _state.modalRoot.on(
      "click",
      '[data-action="decrease-quantity"]',
      function (e) {
        var qtyInput = $(this).siblings('[name="quantity"]');
        var currentQty = parseInt(qtyInput.val());

        var newQty = currentQty - 1;

        if (newQty < 1) newQty = 1;

        qtyInput.val(newQty);

        _state.modalRoot.find(".js-button-atc").attr("data-quantity", newQty);
      },
    );
  }

  this.init = function () {
    insertHtml();
    setupEvents();
    _state.initialised = true;
    return self;
  };

  return self;
};

var SelectOptionsHandler = function () {
  var _state = {
    quickAddModal: new QuickAddModal().init(),
    cachedResults: {},
  };

  var _settings = {};

  var self = this;

  this.getState = function () {
    return { ..._state };
  };

  this.getSettings = function () {
    return { ..._settings };
  };

  this.getSwatchData = function (productId) {
    return new Promise(function (resolve, reject) {
      // [data exists, data]
      var retVal = [false, null];

      try {
        if (_state.cachedResults[productId]) {
          retVal[0] = true;
          retVal[1] = _state.cachedResults[productId];

          return resolve(retVal);
        }

        fetch("https://ba-product-api.fly.dev/product-options/hk/" + productId)
          .then(function (resp) {
            return resp.json();
          })
          .then(function (json) {
            retVal[0] = json.status === "success";
            retVal[1] = json.status === "success" ? json.data[0] : json.data;

            _state.cachedResults[productId] = retVal[1];

            resolve(retVal);
          })
          .catch(function (err) {
            throw err;
          });
      } catch (err) {
        retVal[1] = err;
        reject(retVal);
      }
    });
  };

  this.fallback = function (productId) {
    console.log(
      "Default fallback called for " +
        productId +
        "! Consider handling this using a custom fallback if you require additional logic.",
    );
  };

  this.handleRequest = function (productId, fallbackFn = undefined) {
    return new Promise(function (resolve, reject) {
      try {
        _state.quickAddModal.show(true);

        self
          .getSwatchData(productId)
          .then(function (swatchData) {
            if (!swatchData[0])
              return resolve(
                typeof fallbackFn === "function"
                  ? fallbackFn(productId)
                  : self.fallback(productId),
              );

            resolve(_state.quickAddModal.updateModal(swatchData[1]));
          })
          .catch(reject);
      } catch (err) {
        typeof fallbackFn === "function"
          ? fallbackFn(productId)
          : self.fallback(productId);
        reject(err);
      }
    });
  };

  return self;
};

document.addEventListener('DOMContentLoaded', function () {
  window.selectOptionsHandler = new SelectOptionsHandler();
});
